// @ts-nocheck
import { Skeleton, Box } from '@mui/material';
import './MobileSkeleton.css';

const MobileSkeleton = () => {
  return (
    <div>
      <main>
        <div className='traveler-app__skeleton'>
          {/* Hero Image Skeleton */}
          <Box className='traveler-app__skeleton-hero'>
            <Skeleton
              variant='rectangular'
              width='100%'
              height={400}
              sx={{
                borderRadius: '0',
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }}
            />

            {/* Hero Content Overlay */}
            <Box className='traveler-app__skeleton-hero-content'>
              {/* Date Badge */}
              <Skeleton
                variant='rectangular'
                width={140}
                height={32}
                sx={{
                  borderRadius: '16px',
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  marginBottom: '1rem'
                }}
              />

              {/* Title */}
              <Skeleton
                variant='text'
                width='80%'
                height={48}
                sx={{
                  fontSize: '2rem',
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  marginBottom: '2rem'
                }}
              />

              {/* Logo Box */}
              <Box className='traveler-app__skeleton-logo'>
                <Skeleton
                  variant='rectangular'
                  width={80}
                  height={80}
                  sx={{
                    borderRadius: '12px',
                    backgroundColor: 'rgba(255, 255, 255, 0.9)'
                  }}
                />
              </Box>
            </Box>
          </Box>

          {/* Content Area */}
          <Box className='traveler-app__skeleton-content'>
            {/* Countdown Section */}
            <Box className='traveler-app__skeleton-section'>
              <Skeleton
                variant='text'
                width={200}
                height={24}
                sx={{ marginBottom: '1rem' }}
              />

              <Box className='traveler-app__skeleton-countdown'>
                <Box className='traveler-app__skeleton-countdown-item'>
                  <Skeleton
                    variant='rectangular'
                    width={80}
                    height={80}
                    sx={{ borderRadius: '12px', marginBottom: '0.5rem' }}
                  />
                  <Skeleton variant='text' width={60} height={20} />
                </Box>
                <Box className='traveler-app__skeleton-countdown-item'>
                  <Skeleton
                    variant='rectangular'
                    width={80}
                    height={80}
                    sx={{ borderRadius: '12px', marginBottom: '0.5rem' }}
                  />
                  <Skeleton variant='text' width={60} height={20} />
                </Box>
              </Box>

              <Skeleton
                variant='text'
                width={150}
                height={20}
                sx={{ marginTop: '1rem' }}
              />
            </Box>

            {/* Description Section */}
            <Box className='traveler-app__skeleton-section'>
              <Skeleton
                variant='text'
                width='100%'
                height={20}
                sx={{ marginBottom: '0.5rem' }}
              />
              <Skeleton
                variant='text'
                width='95%'
                height={20}
                sx={{ marginBottom: '0.5rem' }}
              />
              <Skeleton
                variant='text'
                width='90%'
                height={20}
                sx={{ marginBottom: '0.5rem' }}
              />
              <Skeleton
                variant='text'
                width='85%'
                height={20}
                sx={{ marginBottom: '1rem' }}
              />

              <Skeleton
                variant='text'
                width='100%'
                height={20}
                sx={{ marginBottom: '0.5rem' }}
              />
              <Skeleton
                variant='text'
                width='92%'
                height={20}
                sx={{ marginBottom: '0.5rem' }}
              />
              <Skeleton variant='text' width='88%' height={20} />
            </Box>

            {/* Contact Information Section */}
            <Box className='traveler-app__skeleton-section'>
              <Skeleton
                variant='text'
                width={180}
                height={28}
                sx={{ marginBottom: '1rem', fontWeight: 'bold' }}
              />

              {/* Contact Cards */}
              {[1, 2].map((item) => (
                <Box key={item} className='traveler-app__skeleton-contact-card'>
                  <Box className='traveler-app__skeleton-contact-header'>
                    <Skeleton
                      variant='circular'
                      width={40}
                      height={40}
                      sx={{ marginRight: '0.75rem' }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <Skeleton
                        variant='text'
                        width={120}
                        height={20}
                        sx={{ marginBottom: '0.25rem' }}
                      />
                      <Skeleton variant='text' width={80} height={16} />
                    </Box>
                  </Box>

                  <Box className='traveler-app__skeleton-contact-details'>
                    <Skeleton
                      variant='text'
                      width='100%'
                      height={18}
                      sx={{ marginBottom: '0.25rem' }}
                    />
                    <Skeleton variant='text' width='85%' height={18} />
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </div>
      </main>

      {/* Navigation Skeleton */}
      <Box className='traveler-app__skeleton-navigation'>
        <Box className='traveler-app__skeleton-nav-items'>
          {[1, 2, 3, 4].map((item) => (
            <Box key={item} className='traveler-app__skeleton-nav-item'>
              <Skeleton
                variant='circular'
                width={24}
                height={24}
                sx={{ marginBottom: '0.25rem' }}
              />
              <Skeleton variant='text' width={50} height={14} />
            </Box>
          ))}
        </Box>
      </Box>
    </div>
  );
};

export default MobileSkeleton;
